/* eslint-disable */
import { Candidate, DocumentUploadQuestionResponse } from '../../../../../firebase/firestore/documents/candidate';
import { Position } from '../../../../../firebase/firestore/documents/position';

export interface DocumentUploadQuestionItem extends DocumentUploadQuestionResponse {
  answered: boolean;
  skipped: boolean;
}

export default class DocumentUploadQuestionsPresenter {
  readonly questions: DocumentUploadQuestionItem[];

  constructor(position: Position, candidate?: Candidate) {
    const positionQuestions = position?.documentUploadQuestions ?? [];
    const responses = candidate?.documentUploadQuestionResponses ?? [];

    // If the position has no question definitions, fall back to the
    // candidate's own responses so uploaded documents are always visible.
    if (positionQuestions.length === 0) {
      this.questions = responses
        .map((response) => ({
          ...response,
          answers: response?.answers ?? [],
          skipped: response.skipped ?? false,
          answered: Array.isArray(response?.answers) && response?.answers.length > 0,
        }))
        .filter((q) => q.answered || q.skipped);
      return;
    }

    const responseMap = new Map<string, DocumentUploadQuestionResponse>();
    for (const response of responses) {
      if (response?.id) {
        responseMap.set(response.id, response);
      }
    }

    const isMonetized = candidate?.monetized === true;

    const filteredQuestions = isMonetized
      ? positionQuestions.filter((q) => {
          const res = responseMap.get(q.id);
          return res && ((res.answers ?? /* istanbul ignore next */ []).length > 0 || res.skipped);
        })
      : positionQuestions;

    this.questions = filteredQuestions.map((q) => {
      const response = responseMap.get(q.id);

      const answers = response?.answers || [];

      return {
        id: q.id,
        question: q.question,
        isActive: q.isActive,
        isPausable: q.isPausable,
        isSkippable: q.isSkippable,
        questionOrder: q.questionOrder,
        maximumDocumentCount: q.maximumDocumentCount,
        shouldReaskOnReapply: q.shouldReaskOnReapply,
        reviewed: response?.reviewed ?? false,
        answers,
        skipped: response?.skipped ?? false,
        answered: answers.length > 0,
      } as DocumentUploadQuestionItem;
    });
  }

  getQuestionsCount(): number {
    return this.questions.length;
  }

  getAnsweredQuestionsCount(): number {
    return this.questions.filter((q) => q.answered).length;
  }

  hasAnyAnswered(): boolean {
    return this.questions.some((q) => q.answered);
  }
}
